import { render, staticRenderFns } from "./personnel-surename.vue?vue&type=template&id=0f9d783d&scoped=true&"
import script from "./personnel-surename.vue?vue&type=script&lang=js&"
export * from "./personnel-surename.vue?vue&type=script&lang=js&"
import style0 from "./personnel-surename.vue?vue&type=style&index=0&id=0f9d783d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d783d",
  null
  
)

export default component.exports